/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import React from 'react'
import Chip from 'components/commons/chip'
import Button from 'components/commons/button'

const DuplicateNFTsItem = ({
  id,
  slug,
  magic_eden_slug,
  image_url,
  name,
  active,
  opensea_link,
  magic_eden_link,
  onChangeActive,
}: any) => {
  return (
    <tr
      key={id}
      className='bg-white flex flex-col flex-nowrap rounded-lg mb-2 sm:table-row sm:mb-4 md:rounded-none lg:rounded-none'
    >
      <td className='p-4 flex lg:justify-end'>
        <Chip
          className={
            active == null || active
              ? 'bg-green-100 border-green-100 text-green-800 px-4'
              : 'bg-red-100 border-red-100 text-red-800 px-6'
          }
        >
          {active == null || active ? 'Visible' : 'Hidden'}
        </Chip>
      </td>
      <td className='p-4 sm:flex-1'>
        <p className='text-left font-bold md:hidden lg:hidden py-2'>Name & Collection ID</p>
        <div className='flex flex-col lg:items-center lg:flex-row lg:space-x-2'>
          <div className='flex shrink-0'>
            <img src={image_url} width={50} />
          </div>
          <div className='flex-1 truncate'>
            <p>{name}</p>
            <p className='text-sm'>{id}</p>
          </div>
        </div>
      </td>
      <td className='p-4 sm:flex-1' style={{ maxWidth: 200, flexWrap: 'wrap' }}>
        <p className='text-left font-bold md:hidden lg:hidden py-2'>Slug(s)</p>
        <p>{slug}</p>
        {magic_eden_slug && <p>MagicEden: {magic_eden_slug}</p>}
      </td>
      <td className='p-3 sm:flex-1' style={{ maxWidth: 400, flexWrap: 'wrap' }}>
        <p className='text-left font-bold md:hidden lg:hidden py-2'>Links</p>
        {opensea_link && (
          <div className='truncate' style={{ flexWrap: 'wrap' }}>
            <a
              href={opensea_link}
              className='text-blue-500 underline underline-offset-2'
              target='_blank'
              rel='noreferrer'
            >
              {opensea_link}
            </a>
          </div>
        )}
        {magic_eden_link && (
          <div className='truncate'>
            <a
              href={magic_eden_link}
              className='text-blue-500 underline underline-offset-2'
              target='_blank'
              rel='noreferrer'
            >
              {magic_eden_link}
            </a>
          </div>
        )}
      </td>
      <td className='p-4'>
        <div className='flex flex-row items-center space-x-2'>
          <Button
            onClick={() => onChangeActive(id)}
            className={`${
              active ? 'bg-red-500 text-white' : 'bg-gray-200'
            } font-semibold capitalize px-6`}
          >
            {active ? 'Set Active: False' : 'Set Active: True'}
          </Button>
        </div>
      </td>
    </tr>
  )
}

export default DuplicateNFTsItem
